import { put, call, takeLeading } from 'redux-saga/effects';

import * as $ui from 'modules/ui';
import { UI } from 'modules/ui';
import { navigateToInitialRoute } from 'modules/navigation/sagas/navigateToInitialRoute';
import * as $app from 'modules/app';
import * as $userProfile from 'modules/userProfile';
import * as api from '../api';
import * as actions from '../actions';

const authenticateUser = function* (email, password) {
  const user = yield call(api.fetchUserToken, email, password);
  return user;
};

const signin = function* ({ payload }) {
  try {
    const { email, password } = payload;
    const user = yield call(authenticateUser, email, password);
    yield put(actions.setToken(user.Token));
    yield put(actions.setUserEmail(email));
    yield put(actions.setCurrentUser(user));

    const userID = user.User;
    yield put($userProfile.fetchUserProfile(userID));

    yield put($app.updateOnboardingSteps());
  } catch ({ message }) {
    yield put($ui.setUi(UI.Auth.Signin.ErrorMessages, [message]));
  } finally {
    const { callbacks } = payload;
    callbacks.onComplete();
  }
};

const signinNavigateToInitialRoute = function* ({ payload }) {
  yield call(navigateToInitialRoute);

  const { callbacks } = payload;
  callbacks.onComplete();
};

export const signinSaga = function* () {
  yield takeLeading(actions.signin, signin);
  yield takeLeading(actions.signinNavigateToInitialRoute, signinNavigateToInitialRoute);
};
